import React from 'react';
import { motion } from 'framer-motion';

const WhyUsHero = () => {
  return (
    <section className="relative bg-white py-12 sm:py-16 md:py-20 lg:py-32 overflow-hidden">
      {/* Top Green Bar */}
      
      <div className="max-w-full mx-auto">
        {/* Background Prism Image Container */}
        <div className="relative w-full h-[60vh] sm:h-[70vh] md:h-[75vh] lg:h-[80vh] rounded-xl sm:rounded-2xl overflow-hidden mb-8 sm:mb-10 md:mb-12">
          {/* Background Prism Image */}
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat w-full sm:w-[70%] md:w-[60%] lg:w-[50%] h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-[90vh]"
            style={{ backgroundImage: 'url(/images/why-banner.png)' }}
          />
          {/* Text Content Overlay */}
          <div className="absolute inset-0 flex items-center justify-center px-4 sm:px-6 md:px-8 lg:pr-16 h-[60vh] sm:h-[70vh] md:h-[75vh] lg:h-[100vh]">
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-center lg:text-left max-w-xxl lg:max-w-xxl h-[50vh] sm:h-[55vh] md:h-[60vh] lg:h-[60vh] flex flex-col justify-center items-center lg:items-start
              lg:justify-around xl:justify-around xx:justify-around
              "
            >
              {/* Main Heading */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="mb-4 sm:mb-6 max-w-xxl mx-auto lg:mx-0"
              >
                <h1 className="font-source font-light italic leading-tight text-black font-light" style={{ fontSize: 'clamp(2.5rem, 8vw, 7rem)' }}>
                  Who are we?
                </h1>
                <h2 className="font-source font-regular text-[#000000] leading-tight" style={{ fontSize: 'clamp(1.5rem, 5vw, 4rem)' }}>
                  Your journey begins here
                </h2>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
                className="w-full max-w-lg lg:max-w-lg mx-auto lg:mx-0"
              >
                <p className="font-sans font-regular text-base sm:text-lg md:text-xl text-[#113861] leading-relaxed max-w-lg mx-auto lg:mx-0 mt-8 sm:mt-12 md:mt-16 lg:mt-20">
                  Analytical Prism was created with a singular purpose, to help young minds see themselves clearly through the lens of applied psychology.
                </p>
              </motion.div>
            
            </motion.div>
            
          </div>
          
       
      
        </div>
      </div>

      {/* Two-Column Text Section */}
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 mb-12 sm:mb-16 md:mb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-12 xl:gap-20">
          {/* Left Column */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="text-center lg:text-left"
          >
            <p className="font-sans font-regular text-sm sm:text-base md:text-lg lg:text-xl text-[#2b2b2b] leading-relaxed">
              In a world cluttered with information and expectation, students often struggle with self-doubt, indecision, and comparison. Analytical Prism brings science, simplicity, and sensitivity together to decode human behaviour and enable self-discovery.
            </p>
          </motion.div>

          {/* Right Column */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.0 }}
            className="text-center lg:text-left"
          >
            <p className="font-sans font-medium text-sm sm:text-base md:text-lg lg:text-xl text-[#2b2b2b] leading-relaxed mb-4 sm:mb-6">
              Our tools are designed to build Clarity, the emotion that drives confidence, direction, and purpose, while being deeply rooted in cultural intelligence, ensuring relevance and resonance in the Indian context.
            </p>
            <p className="font-sans font-light text-sm sm:text-base md:text-lg lg:text-xl text-[#2b2b2b] leading-relaxed">
              We believe that self-awareness must be culturally grounded to be truly transformative. By partnering with universities, Analytical Prism aims to become a trusted companion in every student's journey from aspiration to actualisation.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Bottom Gradient Bar */}
      <div className="h-1 w-full bg-gradient-to-r from-green-400 via-blue-500 to-orange-500 mt-12 sm:mt-16 md:mt-20"></div>
    </section>
  );
};

export default WhyUsHero;
